/** Public content only. Keep approval emails and evidence outside this client bundle. */
export interface CustomerStory {
  slug: string;
  restaurant: string;
  segment: string;
  location?: string;
  website?: { url: string; label: string };
  afterTitle?: string;
  headline?: { first: string; accent: string };
  highlights?: Array<{ title: string; description: string; icon: string }>;
  title: string;
  summary: string;
  publishedOn: string;
  approvedForPublication: true;
  image?: { src: string; alt: string; width: number; height: number; credit?: string };
  before: string;
  implementation: string;
  after: string;
  modules: Array<{ label: string; href: string }>;
  quote?: { text: string; person: string; role: string };
  results?: Array<{ value: string; label: string; context: string }>;
  context?: string;
}

// Add only real accounts whose final copy and assets were authorized for publication.
// No demonstration restaurant, invented testimonial or inferred performance numbers.
const stories: CustomerStory[] = [
  {
    slug: 'the-met',
    restaurant: 'The Met Pub',
    segment: 'Pub',
    title: 'O pedido saiu do papel. A casa ganhou ritmo.',
    headline: { first: 'O pedido saiu do papel.', accent: 'A casa ganhou ritmo.' },
    summary: 'No The Met Pub, os clientes fazem os próprios pedidos com o Yummo. Sem papel no pedido, com mais velocidade e organização na operação.',
    publishedOn: '2026-09-26',
    approvedForPublication: true,
    website: { url: 'https://themetpub.com.br/', label: 'Abrir o cardápio do The Met' },
    before: 'A operação do The Met precisava de organização. O pedido no papel fazia parte de uma rotina que precisava ganhar mais velocidade e clareza.',
    implementation: 'Com o Yummo, os próprios clientes fazem seus pedidos pelo cardápio digital. Eles escolhem e pedem, sem precisar passar o pedido para o papel. Uma mudança que começa na mesa e faz parte da rotina da casa.',
    afterTitle: 'Mais ritmo. Mais organização.',
    after: 'O The Met ganhou velocidade e organização na operação. O pedido saiu do papel e passou a ser feito pelo próprio cliente.\n\nÉ uma mudança simples de contar e importante para quem vive a rotina de um pub: autonomia para pedir e uma casa mais organizada para atender.',
    highlights: [
      { title: 'O cliente pede.', description: 'Quem está na mesa faz o próprio pedido pelo cardápio digital.', icon: 'phone' },
      { title: 'O papel sai.', description: 'O pedido passa a ser digital. O papel deixa de fazer parte desse caminho.', icon: 'receipt' },
      { title: 'A casa flui.', description: 'Mais velocidade e organização para a rotina da operação.', icon: 'spark' },
    ],
    modules: [{ label: 'Cardápio digital', href: '/digital-menu' }, { label: 'Pedidos digitais', href: '/digital-orders' }],
  },
];
export const publishedStories = stories.filter(story => story.approvedForPublication);
export const hasCustomerStories = publishedStories.length > 0;
export const storyPages = [
  { path: '/stories', label: 'Histórias de clientes', title: 'Histórias de restaurantes com o Yummo', description: 'A rotina de quem usa o Yummo: a casa, o desafio e o que mudou na operação.', noindex: !hasCustomerStories },
  ...publishedStories.map(story => ({ path: `/stories/${story.slug}`, label: story.restaurant, title: `${story.restaurant}: a operação com o Yummo`, description: story.summary })),
];
